import React, { JSX } from 'react';

import { Chip, ChipProps } from '@mui/material';

import type { EoiStatusValue } from '~/types/services/agentHub';

interface Props {
  status: EoiStatusValue;
}

type StatusMap = Record<EoiStatusValue, { color: ChipProps['color']; label: string }>;

function EoiStatusChip({ status }: Props): JSX.Element {
  const STATUS_MAP: StatusMap = {
    pending: { color: 'warning', label: 'Pending' },
    approved: { color: 'primary', label: 'Approved' },
    onboarded: { color: 'success', label: 'Onboarded' },
    rejected: { color: 'error', label: 'Rejected' },
    offboarded: { color: 'error', label: 'Offboarded' },
  };
  const currentStatus = STATUS_MAP[status];

  return <Chip size="small" color={currentStatus.color} label={currentStatus.label} />;
}

export default EoiStatusChip;
